/**
 * Shared table cell for an order's item name.
 * Used by the patient order card and the checkout dialog.
 */
import type { OrderWithRelations } from '@snootsvet/shared'

import { TableCell } from '@/frontend/components/ui/table'

interface OrderItemCellProps {
  order: OrderWithRelations
  className?: string
}

/** Renders the product name in a table cell. */
export function OrderItemCell({ order, className }: OrderItemCellProps) {
  return (
    <TableCell className={className ?? 'truncate font-medium'} title={order.product.name}>
      {order.product.name}
    </TableCell>
  )
}
